import { render, staticRenderFns } from "./FilterGrau.vue?vue&type=template&id=2b340e7e"
import script from "./FilterGrau.vue?vue&type=script&lang=js"
export * from "./FilterGrau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports